import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, SparklesIcon, HeartPulseIcon, LeafIcon, MoonIcon, ShieldIcon } from 'lucide-react';
export function CategorySection() {
  const categories = [{
    name: 'Energie',
    icon: ZapIcon,
    bg: 'bg-vita-orange-pale',
    color: 'text-vita-orange'
  }, {
    name: 'Haut & Haare',
    icon: SparklesIcon,
    bg: 'bg-vita-peach',
    color: 'text-vita-orange-light'
  }, {
    name: 'Hormone',
    icon: HeartPulseIcon,
    bg: 'bg-vita-green-light',
    color: 'text-vita-green-deep'
  }, {
    name: 'Verdauung',
    icon: LeafIcon,
    bg: 'bg-vita-green-pale',
    color: 'text-vita-green-sage'
  }, {
    name: 'Schlaf',
    icon: MoonIcon,
    bg: 'bg-[#F0EBF5]',
    color: 'text-[#8B7BAF]'
  }, {
    name: 'Immunsystem',
    icon: ShieldIcon,
    bg: 'bg-vita-orange-pale',
    color: 'text-vita-orange'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="kategorien" className="py-20 bg-vita-cream" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl md:text-4xl font-bold text-vita-green-deep mb-4" data-id="element-45">
            Themen entdecken
          </h2>
          <p className="text-vita-text-muted max-w-2xl mx-auto" data-id="element-46">
            Finde Antworten auf die Fragen, die dich gerade beschäftigen.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6" data-id="element-47">
          {categories.map((category, index) => {
          const Icon = category.icon;
          return <motion.a key={index} href={`#${category.name.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-')}`} variants={itemVariants} className="group flex flex-col items-center justify-center p-6 bg-white rounded-softer shadow-sm hover:shadow-vita-hover transition-all duration-300 border border-transparent hover:border-vita-border" data-id="element-48">
                <div className={`w-16 h-16 rounded-full ${category.bg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`} data-id="element-49">
                  <Icon className={`w-8 h-8 ${category.color}`} strokeWidth={1.5} data-id="element-50" />
                </div>
                <h3 className="text-sm md:text-base font-medium text-vita-text text-center group-hover:text-vita-green-deep transition-colors duration-200" data-id="element-51">
                  {category.name}
                </h3>
              </motion.a>;
        })}
        </motion.div>
      </div>
    </section>;
}